export const LOAD_LABEL_REVIEW_CLAIM_DATA = 'labelReviewClaimWizard/LOAD_LABEL_REVIEW_CLAIM_DATA';
export const FIELD_EDITED = 'labelReviewClaimWizard/FIELD_EDITED';
export const ADD_BUTTON_CLICKED = 'labelReviewClaimWizard/ADD_BUTTON_CLICKED';
export const DELETE_BUTTON_CLICKED = 'labelReviewClaimWizard/DELETE_BUTTON_CLICKED';
export const REVERT_BUTTON_CLICKED = 'labelReviewClaimWizard/REVERT_BUTTON_CLICKED';
export const ADD_NEW_LABEL_REVIEW_CLAIM = 'labelReviewClaimWizard/NEW_LABEL_REVIEW_CLAIM';
export const REMOVE_LABEL_REVIEW_CLAIM = 'labelReviewClaimWizard/REMOVE_LABEL_REVIEW_CLAIM';
export const UPDATE_LABEL_REVIEW_CLAIM = 'labelReviewClaimWizard/UPDATE_LABEL_REVIEW_CLAIM';
